import { combineReducers } from 'redux';
import Reducer from './index';
import { GetAllCitiesFromStateReducer } from './TenantReducers/TenantReducers';

const rootReducer = combineReducers({
    Maintenance:Reducer.Maintenance,
    CreateMaintenance : Reducer.CreateMaintenance,
    Tenant:Reducer.Tenant,
    CreateTenant : Reducer.CreateTenant,
    Disclaimer: Reducer.Disclaimer,
    CreateDisclaimer: Reducer.CreateDisclaimer,
    AdditionalFee: Reducer.AdditionalFee,
    CreateAdditionalFee: Reducer.CreateAdditionalFee,
    GetAdditionalFee: Reducer.GetAdditionalFee,
    GetAllAdditionalFee: Reducer.GetAllAdditionalFee,
    GetAllDisclaimer: Reducer.GetAllDisclaimer,
    GetAllCitiesFromState: Reducer.GetAllCitiesFromState,
    SetSkippedPayment: Reducer.SetSkippedPayment
});

export default rootReducer;